import axios from "axios";
import { context } from "./config";
/**
 * 動態表記錄 - 上傳文件
 * @param {*} file
 * @param { filename fileType description } fileValue
 * @param {*} code
 * @param {*} columnId
 * @returns
 */
const websiteDynamicUpload = (file, fileValue, params = {}) => {
  const formData = new FormData();
  formData.append("file", file);
  formData.append(
    "fileValue",
    new Blob(
      [
        JSON.stringify({
          ...fileValue,
        }),
      ],
      {
        type: "application/json",
      }
    )
  );
  return axios
    .post(
      `${context}/public/api/v1/website/websiteDynamicTable/attachment/upload`,
      formData,
      {
        params,
      }
    )
    .then((res) => res.data);
};

/**
 * 動態表記錄 - 查詢文件
 * @param {*} columnId
 * @param {*} recordId
 * @returns
 */
const SearchWebsiteTableFile = (data = {}) => {
  return axios
    .post(
      `${context}/public/api/v1/website/websiteDynamicTable/attachment/search`,
      data
    )
    .then((res) => res.data);
};
/**
 * 動態表記錄 - 刪除文件
 * @param {*} attachmentId  文件id
 * @returns
 */
const RemoveWebsiteTableFile = (attachmentId) => {
  return axios
    .post(
      `${context}/public/api/v1/website/websiteDynamicTable/attachment/remove`,
      {},
      {
        params: {
          attachmentId,
        },
      }
    )
    .then((res) => res.data);
};

/**
 * 查詢動態表 - 查詢活動詳情
 * @returns
 */
const getActivity = () => {
  return axios
    .get(`${context}/public/api/v1/website/activity`)
    .then((res) => res.data);
};

export default {
  websiteDynamicUpload,
  SearchWebsiteTableFile,
  RemoveWebsiteTableFile,
  getActivity,
};
